import React from 'react';
import { Box, Typography } from '@mui/material';
import { WidgetDisplayProps } from '../types';
import { WIDGET_DEFINITIONS } from '../constants';

export const WidgetDisplay: React.FC<WidgetDisplayProps> = ({ 
    item, 
    showSpanInfo = false, 
    colSpan = 1, 
    rowSpan = 1 
}) => {
    const definition = WIDGET_DEFINITIONS.find(def => def.type === item.type);
    
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
                padding: 1,
                color: 'white'
            }}
        >
            <Box sx={{ fontSize: '2rem', mb: 1 }}>
                {definition?.icon}
            </Box>
            <Typography variant="caption" sx={{ 
                mt: 0.5, 
                textAlign: 'center',
                color: 'white',
                fontWeight: 600,
                fontSize: '0.75rem'
            }}>
                {definition?.name}
            </Typography>
            {showSpanInfo && (colSpan > 1 || rowSpan > 1) && (
                <Typography variant="caption" sx={{ 
                    color: '#4ade80', 
                    fontSize: '0.7rem',
                    fontWeight: 'bold',
                    mt: 0.5,
                    backgroundColor: 'rgba(0,0,0,0.2)',
                    px: 1,
                    py: 0.25,
                    borderRadius: 1
                }}>
                    {colSpan}×{rowSpan}
                </Typography>
            )}
            {item.content && (
                <Typography variant="caption" sx={{ 
                    color: 'rgba(255,255,255,0.8)', 
                    fontSize: '0.65rem',
                    mt: 0.5,
                    maxWidth: '100%',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                }}>
                    {item.content.substring(0, 20)}{item.content.length > 20 ? '...' : ''}
                </Typography>
            )}
        </Box>
    );
};